import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import AdvanceCarePlanning from "./pages/AdvanceCarePlanning";
import EndOfLifeCoaching from "./pages/EndOfLifeCoaching";
import LegacyProjects from "./pages/LegacyProjects";
import VigilFuneralPlanning from "./pages/VigilFuneralPlanning";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/advance-care-planning" element={<AdvanceCarePlanning />} />
              <Route path="/end-of-life-coaching" element={<EndOfLifeCoaching />} />
              <Route path="/legacy-projects" element={<LegacyProjects />} />
              <Route path="/vigil-and-funeral-planning" element={<VigilFuneralPlanning />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
